import { FC, ReactNode } from "react";
import { Theme, themeRootClassMap } from "apps/website/maps/Theme.map";
import cx from "apps/website/utils/misc/cx";

import { Color } from "../Text/constant";
import TextSubtitle from "../Text/TextSubtitle/TextSubtitle";

export interface IHorizontalRuleStyleOptions {
  backgroundColour?: Theme;
  lineColour?: Theme;
  textColor?: Color;
}

export interface IHorizontalRuleProps {
  children: ReactNode;
  styleOptions?: IHorizontalRuleStyleOptions;
}

const HorizontalRule: FC<IHorizontalRuleProps> = ({
  children,
  styleOptions,
}) => {
  const backgroundColour = styleOptions?.backgroundColour ?? "light";
  const lineColour = styleOptions?.lineColour ?? "dark";
  const textColor = styleOptions?.textColor ?? "default";

  const backgroundClass = themeRootClassMap[backgroundColour];
  const lineClass = themeRootClassMap[lineColour];

  return (
    <div
      className={cx(
        "relative flex items-center justify-center",
        backgroundClass,
      )}
    >
      <div className={`w-full h-1 absolute left-0 transform top-1/2 -translate-y-1/2 ${lineClass}`}></div>
      <TextSubtitle
        size={3}
        align="center"
        color={textColor}
        className={`relative z-10 p-2 ${backgroundClass}`}
      >
        { children }
      </TextSubtitle>
    </div>
  );
};

export default HorizontalRule;
